/* ==========================================================================
   VELMOR MODS - Global Animations & Interaction (GSAP & Lenis)
   ========================================================================== */

document.addEventListener("DOMContentLoaded", () => {
  // 1. Remove Page Load Transition Overlay FIRST to avoid black screen
  const overlay = document.querySelector('.page-transition-overlay');
  if (overlay) {
    if (typeof gsap !== "undefined") {
      gsap.to(overlay, { yPercent: -100, duration: 1.5, ease: "power4.inOut", delay: 0.2 });
    } else {
      overlay.style.display = 'none';
    }
  }

  // 2. Initialize Lenis Smooth Scroll
  try {
    const lenis = new Lenis({
      duration: 1.2,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      direction: 'vertical',
      gestureDirection: 'vertical',
      smooth: true,
      mouseMultiplier: 1,
      smoothTouch: false,
      touchMultiplier: 2,
      infinite: false,
    });

    lenis.on('scroll', ScrollTrigger.update);
    gsap.ticker.add((time) => { lenis.raf(time * 1000); });
    gsap.ticker.lagSmoothing(0);
  } catch (e) {
    console.warn("Lenis init failed", e);
  }

  // 2. Custom Cursor Logic
  const cursor = document.querySelector('.custom-cursor');
  const isTouchDevice = window.matchMedia('(pointer: coarse)').matches || window.innerWidth < 750;

  if (cursor && !isTouchDevice) {
    document.addEventListener('mousemove', (e) => {
      gsap.to(cursor, {
        x: e.clientX,
        y: e.clientY,
        duration: 0.1,
        ease: "power2.out"
      });
    });

    // Add hover state for interactive elements
    const interactiveElements = document.querySelectorAll('a, button, .btn-luxury');
    interactiveElements.forEach(el => {
      el.addEventListener('mouseenter', () => cursor.classList.add('hovering'));
      el.addEventListener('mouseleave', () => cursor.classList.remove('hovering'));
    });
  }



  // 4. Global Text Reveal (Intersection Observer & GSAP)
  const revealElements = document.querySelectorAll('[data-reveal]');
  
  if (document.body.classList.contains('template-collection')) {
    // Disable reveal on collection pages to avoid jank
    if (typeof gsap !== "undefined") {
      gsap.set(revealElements, { opacity: 1, y: 0, rotateX: 0 });
    }
  } else {
    revealElements.forEach(el => {
      const isMobile = window.innerWidth < 750;
      const startY = isMobile ? 12 : 40;
      const startRotateX = isMobile ? 0 : -10;

      gsap.fromTo(el, 
        {
          y: startY,
          opacity: 0,
          rotateX: startRotateX
        },
        {
          y: 0,
          opacity: 1,
          rotateX: 0,
          duration: 1.2,
          ease: "power3.out",
          scrollTrigger: {
            trigger: el,
            start: "top 85%", // reveals when top of element hits 85% of viewport
            toggleActions: "play none none reverse"
          }
        }
      );
    });
  }
});
